import { StartTacoMatch as DLStart, ResetTacoMatch as DLReset, ShowTacoFrontPage as DLShowFrontPage } from './../DL/Tacos'

let tacoSocket = null;
let tacoIsConnected = false;
let tacoReconnectTimeout = null;
let tacoReconnectAttempts = 0;
const MAX_RECONNECT_ATTEMPTS = 10;

let tacoAdminSocket = null;
let isTacoAdminConnected = false;

// ==========================================================================
// 🔌 WEBSOCKET (Dedicado a Taco 1v1)
// ==========================================================================
export const ConnectTacoWebSocket = async (playerId, onStatus = () => {}, onToast = () => {}) => {
    if (tacoSocket || tacoIsConnected) return;

    const connect = () => {
        if (tacoReconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
            onStatus('error'); 
            return;
        }
        
        tacoReconnectAttempts++;
        // Conectamos con el prefijo "taco:player1" o "taco:player2"
        tacoSocket = new WebSocket(`${process.env.REACT_APP_API_URL_WSS}?tipo=taco:${playerId}`);
        onStatus('connecting');

        tacoSocket.onopen = () => {
            tacoIsConnected = true;
            tacoReconnectAttempts = 0;
            onStatus('connected');
            onToast('Conectado a la taquería 🌮');
        };

        tacoSocket.onclose = () => {
            tacoIsConnected = false;
            tacoSocket = null;
            onStatus('reconnecting');
            tacoReconnectTimeout = setTimeout(connect, 2000);
        };

        tacoSocket.onerror = () => onStatus('error');
    };
    connect();
};

export const SetTacoSocketMessageHandler = (handler) => {
    if (!tacoSocket) return;
    tacoSocket.onmessage = (evt) => {
        try { 
            handler(JSON.parse(evt.data)); 
        } catch (error) {}
    };
};

export const ClearTacoSocketMessageHandler = () => {
    if (tacoSocket) tacoSocket.onmessage = null;
};

export const DisconnectTacoWebSocket = () => {
    try {
        if (tacoSocket) {
            tacoSocket.onopen = null;
            tacoSocket.onclose = null;
            tacoSocket.onerror = null;
            tacoSocket.onmessage = null;
            tacoSocket.close();
            tacoSocket = null;
            tacoIsConnected = false;
            clearTimeout(tacoReconnectTimeout);
            tacoReconnectAttempts = 0;
        }
    } catch (error) {}
};

// ==========================================================================
// 📡 REST API (Envío de Taps en Lotes)
// ==========================================================================
const SendTacoTaps = async ({ matchId, playerId, taps }) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Tacos/Tap`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ matchId, playerId, amount: taps })
        });
        return { success: response.ok };
    } catch (error) {
        return { success: false };
    }
};

const ShowTacoFrontPageBL = async () => {
    return await DLShowFrontPage();
};


//=== Admin ===//
const StartTacoGame = async (configData) => {
    if (configData.durationSeconds < 5) return { success: false, message: "El tiempo mínimo es 5 segundos." };
    return await DLStart(configData);
};

const ResetTacoGame = async () => {
    return await DLReset();
};

const ConnectWebSocketForTacoAdmin = (onIncomingMessage, onStatusChange = () => {}) => {
    if (tacoAdminSocket || isTacoAdminConnected) return;

    const connect = () => {
        if (tacoReconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
            onStatusChange('error'); return;
        }
        tacoReconnectAttempts++;
        // Nos conectamos como superadmin para escuchar todo
        tacoAdminSocket = new WebSocket(`${process.env.REACT_APP_API_URL_WSS}?tipo=superadmin`);
        onStatusChange('connecting');

        tacoAdminSocket.onopen = () => {
            isTacoAdminConnected = true;
            tacoReconnectAttempts = 0;
            onStatusChange('connected');
        };

        tacoAdminSocket.onmessage = (event) => {
            try {
                const msg = JSON.parse(event.data);
                // Filtramos solo los mensajes de nuestra dinámica
                if (msg?.type?.startsWith('taco.')) {
                    onIncomingMessage(msg);
                }
            } catch (e) {}
        };

        tacoAdminSocket.onclose = () => {
            isTacoAdminConnected = false;
            tacoAdminSocket = null;
            onStatusChange('reconnecting');
            tacoReconnectTimeout = setTimeout(connect, 2000);
        };
        tacoAdminSocket.onerror = () => onStatusChange('error');
    };
    connect();
};

const DisconnectWebSocketForTacoAdmin = () => {
    if (tacoAdminSocket) {
        tacoAdminSocket.onclose = null;
        tacoAdminSocket.onmessage = null;
        try { tacoAdminSocket.close(); } catch (e) {}
    }
    tacoAdminSocket = null;
    isTacoAdminConnected = false;
    clearTimeout(tacoReconnectTimeout);
    tacoReconnectAttempts = 0;
};
//=== Admin ===//

export { SendTacoTaps, ShowTacoFrontPageBL, StartTacoGame, ResetTacoGame, ConnectWebSocketForTacoAdmin, DisconnectWebSocketForTacoAdmin };